import type { EChartsOption } from 'echarts';

import { buildAnimationConfig } from '../shared/animation';
import { buildTooltipConfig, buildStackedSwatchBody } from '../shared/tooltip';
import { buildSpendingPlanGraphSeries } from './series';
import type { SpendingPlanGraphConfig, SpendingPlanGraphDatum } from './types';

type TooltipParam = { dataIndex?: number };

export const buildSpendingPlanGraphOption = (
  data: SpendingPlanGraphDatum[],
  config: SpendingPlanGraphConfig,
): EChartsOption => ({
  ...buildAnimationConfig(!config.zeroState),
  textStyle: { fontFamily: config.theme.fontFamily },
  tooltip: {
    ...buildTooltipConfig(config.theme),
    trigger: 'item',
    formatter: (params: unknown): string => {
      if (config.zeroState) return '';
      const parameter = (Array.isArray(params) ? params[0] : params) as TooltipParam;
      const datum = typeof parameter?.dataIndex === 'number' ? data[parameter.dataIndex] : undefined;
      if (!datum?.displayAmount) return '';
      // SIMPL-34793: the amcharts tooltip took its background from the slice fill. Design retired
      // that (dark slice colors failed contrast) in favour of the shared pie treatment — a color
      // swatch beside the label and amount on the paper background.
      const name = config.isMiniCard ? '' : (datum.name ?? '');
      return buildStackedSwatchBody(datum.color, name, datum.displayAmount, config.theme);
    },
  },
  series: [buildSpendingPlanGraphSeries(data, config)],
});

export type { SpendingPlanGraphConfig, SpendingPlanGraphDatum } from './types';
